import { Component, inject, Input } from '@angular/core';
import {
  ServiceNotificationIcon,
  ServiceNotificationItem
} from '@brightside-web/desktop/feature/service-notifications';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { getRouteForKey } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-info',
    imports: [BrightsideUiModule],
    templateUrl: './info.component.html',
    styleUrl: './info.component.css'
})
export class InfoComponent {
  @Input() notificationItem: ServiceNotificationItem;
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);

  constructor() { }

  ngOnInit() {
    this.actionCardConfig = this.mapToActionCardConfig(this.notificationItem);
  }

  mapToActionCardConfig(item: ServiceNotificationItem): ActionCardConfigInterface {
    return {
      label: this._translateSvc.instant(item.copy1),
      title: this._translateSvc.instant(item.copy2),
      body: this._translateSvc.instant(item.copy3),
      labelIcon: ServiceNotificationIcon[item.state] ?? '',
      cardStyle: 'small',
      shadow: !item.read,
      hideCta: true,
      bgColor: item.read ? '#e6e6e6' : 'white'
    };
  }

}
